import { handleHideModal } from 'components/global/_helpers/global.helpers';
import InvestorPortfolioForm from 'components/global/InvestorPortfolioForm';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitUpdatePortfolio } from 'components/views/InvestorPortfolioList/_helpers/investorPortfolioList.events';
import { $view } from 'signals/global.signals';

const InvestorPortfolioEditModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'investor-portfolio-edit'}
    title="Edit Portfolio"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitUpdatePortfolio}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <InvestorPortfolioForm />
  </SimpleModal>

);

export default InvestorPortfolioEditModal;
